export interface VoiceOption {
  label: string;
  value: string;
  providerId: string;
  stability: number;
  similarity_boost: number;
  speed: number;
  use_speaker_boost: boolean;
}

export const voiceOptions: VoiceOption[] = [
  {
    label: 'Anika (Female)',
    value: 'anika',
    providerId: 'broqrJkktxd1CclKTudW',
    stability: 0.2,
    similarity_boost: 0.2,
    use_speaker_boost: true,
    speed: 0.9,
  },
  {
    label: 'Ruhaan (Male)',
    value: 'ruhaan',
    providerId: 'F9Nt4wN7louPPlCeLCMN',
    stability: 0.8,
    similarity_boost: 0.8,
    use_speaker_boost: true,
    speed: 0.9,
  },
  {
    label: 'Raju (Male)',
    value: 'raju',
    providerId: 'pzxut4zZz4GImZNlqQ3H',
    stability: 0.5,
    similarity_boost: 0.8,
    use_speaker_boost: true,
    speed: 1,
  },
];
